import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
  handlePostUserVisitsData,
  handleExportUserVisitsData,
} from './userVisitsArchive.helpers';
import {
  postUserVisitsDataSuccess,
  exportUserVisitsDataSuccess,
  makeIsFetchingTrue,
  makeExportIsFetchingTrue,
} from './userVisitsArchive.actions';
import { userVisitsArchiveTypes } from './userVisitsArchive.types';
import { handleErrors, getNotifMsg } from 'utils';
import { toast } from 'react-toastify';

const mapState = ({ appData }) => ({
  locale: appData.locale,
});

export function* postUserVisitsDataSaga(action) {
  const { locale } = yield select(mapState);
  try {
    yield put(makeIsFetchingTrue());
    const response = yield call(handlePostUserVisitsData, action.payload);

    if (response.success) {
      yield put(postUserVisitsDataSuccess(response));

      return;
    }

    toast.error(getNotifMsg('REQUEST_ADD_FILTER_FAILURE', locale));
  } catch (error) {
    handleErrors(error);
  }
}

export function* exportUserVisitsDataSaga(action) {
  const { locale } = yield select(mapState);
  try {
    yield put(makeExportIsFetchingTrue());
    const response = yield call(handleExportUserVisitsData, action.payload);

    if (
      response.message ===
      'start to exporting, we`ll email you the link as soon as it get ready'
    ) {
      yield put(exportUserVisitsDataSuccess(response));

      return toast.success(
        getNotifMsg('REQUEST_EXPORT_USER_VISITS_SUCCESS', locale)
      );
    }

    toast.error(getNotifMsg('REQUEST_EXPORT_USER_VISITS_FAILURE', locale));
  } catch (error) {
    if (
      error.response?.data?.message === 'you can only export 2 times in day'
    ) {
      toast.error(getNotifMsg('CONVS_ARCHIVE_EXPORT_LIMIT', locale));
      return;
    }
    handleErrors(error);
  }
}

export function* onPostingUserVisitsData() {
  yield takeLatest(
    userVisitsArchiveTypes.POST_USER_VISITS_DATA,
    postUserVisitsDataSaga
  );
}

export function* onExportingUserVisitsData() {
  yield takeLatest(
    userVisitsArchiveTypes.EXPORT_USER_VISITS_DATA,
    exportUserVisitsDataSaga
  );
}

export default function* userVisitsSaga() {
  yield all([call(onPostingUserVisitsData), call(onExportingUserVisitsData)]);
}
